import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { Link } from "react-router-dom";

function HistoryMobileSelector({ articles, activeSlug }) {
  const categories = [...new Set(articles.map((article) => article.category))];

  const activeArticle = articles.find((article) => article.slug === activeSlug);

  return (
    <Popover className="relative mb-8 lg:hidden">
      {({ close }) => (
        <>
          <PopoverButton className="flex w-full items-center justify-between rounded-lg border border-gray-200 bg-white px-4 py-3 text-left shadow-sm">
            <span>{activeArticle?.title || "Seleziona un articolo"}</span>

            <i className="fas fa-chevron-down text-xs" />
          </PopoverButton>

          <PopoverPanel
            anchor="bottom"
            className="z-50 mt-2 w-[var(--button-width)] rounded-lg border border-gray-200 bg-white p-2 shadow-lg"
          >
            {categories.map((category) => {
              const categoryArticles = articles.filter(
                (article) => article.category === category,
              );

              return (
                <div key={category} className="mb-3 last:mb-0">
                  <div className="px-3 py-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
                    {category}
                  </div>

                  <div>
                    {categoryArticles.map((article) => (
                      <Link
                        key={article.slug}
                        to={`/pillole-di-storia/${article.slug}`}
                        onClick={close}
                        className={`
                          block rounded-md px-3 py-2 text-sm
                          transition-colors
                          ${
                            article.slug === activeSlug
                              ? "bg-gray-100 font-semibold"
                              : "hover:bg-gray-50"
                          }
                        `}
                      >
                        <span className="flex items-center justify-between gap-3">
                          {article.title}

                          {article.slug === activeSlug && (
                            <i className="fas fa-check text-xs" />
                          )}
                        </span>
                      </Link>
                    ))}
                  </div>
                </div>
              );
            })}
          </PopoverPanel>
        </>
      )}
    </Popover>
  );
}

export default HistoryMobileSelector;
